/* eslint-disable radix */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import CartilhaProcom from "../../../assets/documents/cartilha-procon.pdf";
import PerguntasList from "../PerguntasRespostas/PerguntasList";

// Images
import MeiaEntradaEstudantil from "../../../assets/images/meia-entrada-estudantil.png";
import BancoDeDadosUnificado from "../../../assets/images/banco-de-dados-unificados.png";
import ControleSocial from "../../../assets/images/controle-social.png";

export default class HomePage extends Component {
  constructor() {
    super();
    this.state = { perguntas: [] };
  }

  addDadosEstruturadosScript() {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.type = "application/ld+json";
    script.innerHTML = `{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Quem tem direito a meia entrada?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Em resumo, estudantes com <a href='https://www.documentodoestudante.com.br/?utm_source=meia&utm_medium=serp-meia&utm_campaign=serp-meia'>DNE</a>, idosos, jovens de baixa renda de 15 a 29 anos e PCD + acompanhante têm direito a meia entrada."
            }
          }
        ]
      }`;

    head.appendChild(script);
  }

  componentWillMount() {
    let currentUrl = window.location.href;
    if (currentUrl.indexOf("#val") > -1) {
      const values = currentUrl.match(/#val.*/g)[0].split("/");
      const date_url = new Date(parseInt(values[3]));
      const utc = date_url.getTime() + date_url.getTimezoneOffset() * 60000;
      const date = new Date(utc + 3600000 * -3);
      const dateFormatted = `${date.getUTCFullYear()}${`0${
        date.getUTCMonth() + 1
      }`.slice(-2)}${`0${date.getUTCDate()}`.slice(-2)}`;
      this.props.history.push(`/val/${values[1]}/${dateFormatted}`);
    }

    this.addDadosEstruturadosScript();
  }

  componentDidMount() {
    this.setState({ perguntas: PerguntasList.getList() });
  }

  render() {
    return (
      <div id="HomeBlock">
        {/*
        <section className="py-5">
          <div className="container">
            <div className="row align-items-center justify-content-between">

              <div className="col-md-7 order-md-2">

                <h1 className='font-title'>
                  Validação de Meia-entrada estudantil
                </h1>

                <p>
                  Ao integrar o sistema de vendas, <b>os estabelecimentos (cinemas, teatros, etc), produtoras e
                  promotoras</b> evitam fraudes e comprovam o cumprimento integral da Lei nº 12.933/2013 da
                  Meia-entrada.
                </p>

                <div className="text-center mt-4">
                  <Link to="/validador/integre" className="btn btn-success btn-lg px-sm-5">
                    Quero integrar
                  </Link>
                </div>

              </div>

              <div className="col-md-4 mt-4 mt-md-0 text-center">
                <img src={MeiaEntradaEstudantil} alt="Meia-entrada estudantil"/>
              </div>

            </div>
          </div>
        </section>

        */}

        <section className="py-5 text-light bg-blue-meiaentrada">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7">
                <h3 className="font-title">Validação da CIE</h3>

                <p>
                  Ao verificar e validar as chaves públicas dos certificados de
                  atributos, <b>as entidades estudantis</b> asseguram a
                  validação da meia-entrada em todo território nacional com
                  segurança e transparência, trabalhando a favor dos direitos
                  dos estudantes.
                </p>

                <div className="text-center mt-4">
                  <Link
                    to="/chaves-publicas"
                    className="btn btn-success btn-lg px-sm-5"
                  >
                    Quero validar
                  </Link>
                </div>
              </div>

              <div className="col-md-4 mt-4 mt-md-0 text-center">
                <img
                  src={BancoDeDadosUnificado}
                  alt="Banco de dados unificado"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-5">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7 order-md-2">
                <h3 className="font-title">Direitos e Deveres</h3>

                <p>
                  Acompanhar o cumprimento da Lei nº 12.933/2013 da Meia-Entrada
                  por entidades estudantis, estudantes e estabelecimentos
                  responsáveis é um dever do Estado e um direito de toda a
                  sociedade.
                </p>

                <div className="mt-4">
                  <div>
                    <Link
                      to="/cumprimento-da-cota"
                      className="btn btn-success col col-md-auto btn-lg px-sm-5"
                    >
                      40% de ingressos
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-4 mt-md-0 text-center">
                <img src={ControleSocial} alt="Controle Social" />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-blue-meiaentrada pt-4 pb-5 faq-home">
          <div className="container-fluid mb-5">
            <h2 className="text-center font-title">Perguntas Frequentes</h2>
          </div>

          <div className="container">
            <div className="row">
              <div className="col">
                <div className="text-light ">
                  <ul className="pl-3">
                    <li>
                      Faça o download da cartilha{" "}
                      <a
                        href={CartilhaProcom}
                        className="text-white"
                        target="blank"
                      >
                        <b>
                          <u>O direito estudantil à meia-entrada</u>
                        </b>
                      </a>{" "}
                      em parceria com o PROCON.
                    </li>
                  </ul>
                </div>

                <div id="accordion" role="tablist" className="faq-questions">
                  {this.state.perguntas.map((pergunta) => {
                    return (
                      <div key={pergunta.id}>
                        <div className="card mb-2">
                          <a
                            className="collapsed question-title-link"
                            data-toggle="collapse"
                            href={`#collapse${pergunta.id}`}
                            aria-expanded="false"
                            aria-controls={`collapse${pergunta.id}`}
                          >
                            <div
                              className="card-header"
                              role="tab"
                              id={`heading${pergunta.id}`}
                            >
                              <h5 className="mb-0">{pergunta.pergunta}</h5>
                            </div>
                          </a>

                          <div
                            id={`collapse${pergunta.id}`}
                            className="collapse"
                            role="tabpanel"
                            aria-labelledby={`heading${pergunta.id}`}
                            data-parent="#accordion"
                          >
                            <div
                              className="card-body"
                              dangerouslySetInnerHTML={{
                                __html: pergunta.resposta,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Home/HomePage.js